<template>
  <div>
    <div>
      <div v-if="loaded && adminUsers.length === 0">
        <div class="alert alert-primary" role="alert">کاربری یافت نشد.</div>
      </div>
    </div>
    <div v-if="loaded && adminUsers.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نام</th>
                <th>تلفن</th>
                <th>مجموع پراخت ها (ریال)</th>
                <th>عملیات ها</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in adminUsers" :key="user.id">
                <td>{{ gFullName(user) || "_" }}</td>
                <td dir="ltr">
                  <a :href="`tel:${user.cellphone}`">
                    {{ prettyPhone(user.cellphone) }}
                  </a>
                </td>
                <td>
                  {{ numberFormat(user.sum) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'admin-users-show',
                      params: { id: user.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="adminUsersPagination.lastPage > 1">
      <b-pagination
        v-model="adminUsersPagination.currentPage"
        :total-rows="adminUsersPagination.total"
        :per-page="adminUsersPagination.perPage"
        aria-controls="my-table"
        @input="updateUsers()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_ADMIN_MOST_VALUABLE_USERS } from "@/core/services/store/admin/users.module.js";
import { mapGetters } from "vuex";

export default {
  name: "adminUsers",
  data() {
    return {
      loaded: false,
      searchUser: ""
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "کاربران", route: { name: "admin-users-index" } },
      { title: "کاربران ویژه" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "admin-users-create" },
          class: "btn-primary"
        }
      ]
    });

    this.updateUsers();
  },
  computed: {
    ...mapGetters(["currentUserProperty", "adminUsers", "adminUsersPagination"])
  },
  methods: {
    updateUsers() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_MOST_VALUABLE_USERS, {
          cellphone: this.searchUser
        })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
